import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Django protip #1: A better App structure",
  "description": "",
  "published": "2010-07-21T00:00:00.000Z",
  "redirect_from": ["/blog/django-protip-1-a-better-app-structure/swizec/1386"],
  "categories": "Application programming interface, django, Languages, Programming, python, Uncategorized, Web Frameworks",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "http://en.wikipedia.org/wiki/File:Derfflinger%27s_crow%27s_nest.JPG"
          }}><img parentName="a" {...{
              "src": "https://swizec.com/blog/wp-content/uploads/2010/07/300px-Derfflinger%27s_crow%27s_nest.jpg",
              "alt": "Crow's nest of SMS Derfflinger",
              "title": "Crow's nest of SMS Derfflinger"
            }}></img></a></p>
        <p parentName="li">{`Image via `}<a parentName="p" {...{
            "href": "http://en.wikipedia.org/wiki/File:Derfflinger%27s_crow%27s_nest.JPG"
          }}>{`Wikipedia`}</a></p>
      </li>
    </ul>
    <p>{`When I started coding for our latest project at Preona a bit of an epiphany happened. I suddenly `}<em parentName="p">{`got`}</em>{` django. Every pattern that used to feel a bit strange and I may have fought a little, suddenly became obvious and simple. Suddenly out of the blue my whole `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Codebase",
        "title": "Codebase"
      }}>{`codebase`}</a>{` is so marvelously organised and separated into files it brings a tear to my eye.`}</p>
    <p>{`In the old days the average `}<a parentName="p" {...{
        "href": "http://www.djangoproject.com",
        "title": "Django (web framework)"
      }}>{`Django`}</a>{` App in my project had a structure a file structure a bit like so:`}</p>
    <ul>
      <li parentName="ul">{`models.py`}</li>
      <li parentName="ul">{`views.py`}</li>
      <li parentName="ul">{`tests.py`}</li>
      <li parentName="ul">{`RandomActualWorkLogic.py`}</li>
      <li parentName="ul">{`AnotherRandomOfWork.py`}</li>
      <li parentName="ul">{`...`}</li>
    </ul>
    <p>{`Sure this works quite alright, but it feels a little weird and after way too much work you suddenly realise that instead of the clean design you envisioned as you started out, you're left with a `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Crow%27s_nest",
        "title": "Crow's nest"
      }}>{`crow's nest`}</a>{` of interdependancy, circular crappery and your project is in pretty miserable shape.`}</p>
    <p>{`This point was really driven home when I figured two different django projects should share some code. Extrapolating a clean interface and making stuff work ... was a nightmare. I actually gave up after a week and decided to start afresh.`}</p>
    <p>{`And boy, was that the best decision ever!`}</p>
    <h2 {...{
      "id": "better-application-software-structure"
    }}>{`Better `}<a parentName="h2" {...{
        "href": "http://en.wikipedia.org/wiki/Application_software",
        "title": "Application software"
      }}>{`application`}</a>{` structure`}</h2>
    <p>{`The first step was to take up a better way to organise my codebase inside applications. It goes something like this:`}</p>
    <ul>
      <li parentName="ul">{`models.py`}</li>
      <li parentName="ul">{`managers.py`}</li>
      <li parentName="ul">{`views.py`}</li>
      <li parentName="ul">{`tests.py`}</li>
      <li parentName="ul">{`forms.py`}</li>
      <li parentName="ul">{`decorators.py`}</li>
      <li parentName="ul">{`processing.py -- `}<em parentName="li">{`(this is for certain special views)`}</em></li>
      <li parentName="ul">{`urls.py`}</li>
      <li parentName="ul">{`settings.py`}</li>
    </ul>
    <p>{`The first result of this organisation is that now everything has its own place. There are no StrangeWorker.py crappy things anymore. All of those reside in a special 'application' just for those called a `}{`_`}{`lib. `}{`_`}{`Whenever you are making something and are looking for a place to put it -> the file is an obvious pick!`}</p>
    <p>{`Another great result is that it's now much easier to keep applications contained within themselves. Because both its specific url config and its specific settings config are contained within the application you can easily switch it around between projects or even make it a standalone thingy that projects can simply include.`}</p>
    <p>{`Also because the file structure makes sense now and all those WeirdoWorker.py are separated elsewhere as proper libraries, there is less of a temptation to create mixed and confusing dependancies all over the place.`}</p>
    <h2 {...{
      "id": "conclusion"
    }}>{`Conclusion`}</h2>
    <p>{`That's it for django application structure. If you've got any better ideas do mention them on twitter or via the comments below. If not, that's alright :P`}</p>
    <p>{`Either way, join me in the next installment of Django Protip when I'll be talking about using "Forms, forms for everything"`}</p>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=1985aade-c198-44e0-a12f-c32c11144665",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      